import React from 'react';
import './assets/styles/app.less';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Navigation from './components/Navigation/index';
import { store, persistor } from 'store';

const App: React.FC = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Navigation />
    </PersistGate>
  </Provider>
);

export default App;
